module.exports = __webpack_public_path__ + "static/images/jf-spike-yjs.93ca5cd.png";